module.exports = __webpack_public_path__ + "img/levelup2.2a962355.png";